import { render, staticRenderFns } from "./SendTemplateBtn.vue?vue&type=template&id=44dda361&scoped=true"
import script from "./SendTemplateBtn.vue?vue&type=script&lang=js"
export * from "./SendTemplateBtn.vue?vue&type=script&lang=js"
import style0 from "./SendTemplateBtn.vue?vue&type=style&index=0&id=44dda361&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dda361",
  null
  
)

export default component.exports